import { defaultLocale } from 'utils/i18n';

export async function getUserLocale() {
  return defaultLocale;
}
